import { styles } from './template.scss';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${styles}</style>

  <div id='wrapper' hidden>
    <div class='actions-item-wrapper'>
      <gz-form-field class='actions-checkbox' id='checkbox-form-field'>
        <gz-checkbox gz-form-input color='primary'></gz-checkbox>
      </gz-form-field>

      <div id='dropdown-container' hidden>
        <gz-form-field class='actions-dropdown' id='dropdown-form-field'>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
